import { DocumentNode, gql } from '@apollo/client';
import { MenuItem, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { PostingExperience } from '@/components/PostingExperience';
import { usePostingExperience } from '@/components/PostingExperience/usePostingExperience';
import { EditIcon } from '@/imports/ui/chakra/feather';

import { EditPostDropdownItem_PostFragment } from './graphql-types/EditPostDropdownItem_PostFragment';

import { EditAnswerModal } from './components/EditAnswerModal';
import { EditPollModal } from './components/EditPollModal';
import { EditQuestionModal } from './components/EditQuestionModal';
import { EditSimplePostModal } from './components/EditSimplePostModal';

const POST_FRAGMENT = gql`
  fragment EditPostDropdownItem_PostFragment on PostV2 {
    _id
    group {
      _id
      name
    }
    organization {
      _id
      name
    }
    tags {
      _id
      name
    }
    ...EditSimplePostModal_PostFragment
    ...EditQuestionModal_PostFragment
    ...EditAnswerModal_PostFragment
    ...EditPollModal_PollFragment
  }
  ${EditSimplePostModal.postFragment}
  ${EditQuestionModal.postFragment}
  ${EditAnswerModal.postFragment}
  ${EditPollModal.pollFragment}
`;

export const EditPostDropdownItem: React.FC<{
  post: EditPostDropdownItem_PostFragment;
}> & {
  postFragment: DocumentNode;
} = (props) => {
  const { post } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const postingExperience = usePostingExperience();

  return (
    <>
      <MenuItem
        icon={<EditIcon />}
        onClick={
          post.__typename === 'BlogV2'
            ? postingExperience.createArticle
            : onOpen
        }
      >
        Edit
      </MenuItem>
      {post.__typename === 'BlogV2' ? (
        <PostingExperience
          {...postingExperience}
          onDrawerClose={() => {
            postingExperience.onDrawerClose();
          }}
          options={{
            postId: props.post._id,
            tags: post.tags ? post.tags : undefined,
            group: post.group ? post.group : undefined,
            organization: post.organization ? post.organization : undefined,
          }}
        />
      ) : post.__typename === 'SimplePost' ? (
        <EditSimplePostModal isOpen={isOpen} onClose={onClose} post={post} />
      ) : post.__typename === 'QuestionV2' ? (
        <EditQuestionModal isOpen={isOpen} onClose={onClose} post={post} />
      ) : post.__typename === 'AnswerV2' ? (
        <EditAnswerModal isOpen={isOpen} onClose={onClose} post={post} />
      ) : post.__typename === 'PollV2' ? (
        <EditPollModal isOpen={isOpen} onClose={onClose} post={post} />
      ) : null}
    </>
  );
};
EditPostDropdownItem.postFragment = POST_FRAGMENT;
